<template>
    <div>
        <!-- <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone> -->
        <div class="card shadow-sm border-0 mt-3">
            <div class="header px-3 py-3 border-bottom">
                <h5 class="font-weight-bold p-0 m-0">Create a pool</h5>
            </div>
            <div class="card-body py-3">
                <form @submit.prevent="createPool()">
                    <div class="row">
                        <div class="col-md-3">
                            <h6 class="font-weight-bold">Pool Title</h6>
                        </div>
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-lg-6">

                                    <div class="form-group mb-3 align-items-center justify-content-center">
                                        <label for="username" class="text-dark my-0 mb-1">
                                            <small>Title of Pool (e.g - Fantasy Football League 2019)</small> 
                                        </label>
                                        <input class="form-control mb-1" :class="status($v.form.title)" v-model.lazy="$v.form.title.$model" type="text" autofocus>
                                        
                                        <p class="text-danger small" v-if="$v.form.title.$dirty && !$v.form.title.required">This field is required</p>
                                    </div>

                                </div>
                                <div class="col-lg-6">
                                    <label for="username" class="text-dark my-0 mb-1">
                                        <small>Description of Pool </small> 
                                    </label>
                                    <div class="form-group mb-1 align-items-center justify-content-center">
                                        <textarea class="form-control" :class="status($v.form.description)" v-model.lazy="$v.form.description.$model" type="text"></textarea>
                                    </div>
                                    <p class="text-danger small" v-if="$v.form.description.$dirty && !$v.form.description.required">This field is required</p>

                                </div>
                            </div>

                        </div>
                    </div> <hr>

                    <div class="row">
                        <div class="col-md-3">
                            <h6 class="font-weight-bold">Contributors</h6>
                        </div>
                        <div class="col-md-9">
                            <div class="row">
                                <div class="col-lg-6 mb-3">
                                    <label for="username" class="text-dark my-0 mb-1">
                                        <small>Each member contributes? (e.g - 5,000)</small> 
                                    </label>
                                    <div class="form-group mb-1">
                                        <input class="form-control" :class="status($v.form.amount_payable)" v-model.number="$v.form.amount_payable.$model" type="number" required autofocus>
                                    </div>
                                    <p class="text-danger small" v-if="$v.form.amount_payable.$dirty && !$v.form.amount_payable.required">This field is required</p>
                                </div>
                                <div class="col-lg-6">
                                    <label for="username" class="text-dark my-0 mb-1">
                                        <small>Does Organizer contribute? </small> 
                                    </label>
                                    <div class="">

                                        <div class="custom-control custom-radio mb-3 mr-5">
                                            <input type="radio" class="custom-control-input" v-model="$v.form.does_org_contrib.$model" value="true" id="yes">
                                            <label class="custom-control-label text-muted" for="yes">Yes</label>
                                        </div>

                                        <div class="custom-control custom-radio">
                                            <input type="radio" class="custom-control-input" v-model="$v.form.does_org_contrib.$model" value="false" id="no">
                                            <label class="custom-control-label text-muted" for="no">No</label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div> <hr>

                    <div class="row">
                        <div class="col-md-3">
                            <h6 class="font-weight-bold">Disbursement Mode</h6>
                        </div>
                        <div class="col-md-9">
                            <div class="col-md-6 p-0">
                                <label for="username" class="text-dark my-0 mb-2">
                                    <small>Who decides on the disbursement </small> 
                                </label><br>

                                <div class="d-lg-flex">

                                    <div class="custom-control custom-radio mb-3 mr-5">
                                        <input type="radio" class="custom-control-input" v-model="form.payout_rule" value="majority-vote" id="majority-vote">
                                        <label class="custom-control-label text-muted" for="majority-vote"> Majority Vote</label>
                                    </div>

                                    <div class="custom-control custom-radio">
                                        <input type="radio" class="custom-control-input" v-model="form.payout_rule" value="organizer-autonomy" id="organizer-autonomy">
                                        <label class="custom-control-label text-muted" for="organizer-autonomy"> Decided by me</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> <hr>

                    <div class="row">
                        <div class="col-md-3">
                            <h6 class="font-weight-bold">Pool Deadlines</h6>
                        </div>
                        <div class="col-md-9">
                            <div class="row">

                                <div class="col-md-6">
                                    <div class="">
                                        <label for="username" class="text-dark my-0 mb-1">
                                            <small> Contribution Deadline</small> 
                                        </label>
                                        <datepicker 
                                            :disabled-dates="disabledDates" 
                                            v-model="$v.form.contrib_deadline.$model"
                                            :format="format"
                                            :required="true"
                                            @selected="disablePayoutDates"
                                            :input-class="formControl">
                                        </datepicker>
                                        <p class="text-danger small" v-if="$v.form.contrib_deadline.$dirty && !$v.form.contrib_deadline.required">Contribution deadline is required</p>

                                        <!-- <div class="form-group mb-2 align-items-center justify-content-center">
                                            <input class="form-control" :class="status($v.form.contrib_deadline)" v-model.lazy="$v.form.contrib_deadline.$model" type="date" required>
                                            <p class="text-danger small" v-if="!$v.form.contrib_deadline.required">Contribution deadline is required</p>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="">
                                        <label for="username" class="text-dark my-0 mb-1">
                                            <small> Payout Deadline</small> 
                                        </label>
                                        <datepicker 
                                            :disabled-dates="payout_deadline_disabled" 
                                            v-model="$v.form.payout_deadline.$model"
                                            :format="format"
                                            :required="true"
                                            @selected="disableContributionDates"
                                            :input-class="formControl">
                                        </datepicker>
                                        <p class="text-danger small" v-if="$v.form.payout_deadline.$dirty && !$v.form.payout_deadline.required">Payout deadline is required</p>

                                        <!-- <div class="form-group mb-2 align-items-center justify-content-center">
                                            <input class="form-control" :class="status($v.form.payout_deadline)" v-model.lazy="$v.form.payout_deadline.$model" type="date" required>
                                            <p class="text-danger small" v-if="!$v.form.payout_deadline.required">Payout deadline is required</p>
                                        </div> -->
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div><hr>

                    <div class="row mt-4">
                        <div class="col-md-12 mb-3 d-md-flex">
                            <h6 class="font-weight-bold mr-2">Add Contributors </h6>
                            <small class="text-danger">(At least 2 contributors)</small>
                            
                        </div>
                        <div class="col-md-12 table-responsive">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col" class="font-weight-normal">Name</th>
                                        <th scope="col" class="font-weight-normal">Phone Number</th>
                                        <th scope="col" class="font-weight-normal">Email Address</th>
                                        <th scope="col" class="font-weight-normal">Reminders</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(invitee, index) in form.invitees" :key="index">
                                        <th scope="row">{{ index + 1 }}</th>
                                        <td >
                                            <div class="form-group mb-3">
                                                <input class="form-control" placeholder="" v-model="invitee.name" type="text" required autofocus>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group mb-3">
                                                <div class="form-group mb-3 align-items-center justify-content-center">
                                                    <vue-tel-input @country-changed="getCountry($event, index)" v-model="invitee.phone" v-bind="bindProps"></vue-tel-input>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="form-group mb-3">
                                                <input class="form-control" type="email" v-model="invitee.email" required>
                                            </div>
                                        </td>
                                        <td>
                                            <div class="d-flex">
                                                <div class="custom-control custom-checkbox mr-2">
                                                    <input type="checkbox" class="custom-control-input" value="sms" v-model="invitee.sms_notify" :id="'customSms_'+ index">
                                                    <label class="custom-control-label text-muted" :for="'customSms_'+ index">Sms</label>
                                                </div>
                                                <div class="custom-control custom-checkbox">
                                                    <input type="checkbox" class="custom-control-input" value="email" :id="'customEmail_'+ index" v-model="invitee.email_notify">
                                                    <label class="custom-control-label text-muted" :for="'customEmail_'+ index"> Email</label>
                                                </div>

                                            </div>
                                        </td>
                                        <td>
                                            <button class="btn-outline-danger btn-sm"
                                                @click.prevent="removeContributor(index)">
                                                <span class="fa fa-trash"></span>

                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="col-md-12">
                            <button class="btn-sm btn-outline-dark float-right" @click.prevent="addContributor()">+ Add</button>
                        </div>
                    </div> <hr>

                    <div class="col-md-12 p-0">
                        <div class="d-none d-md-block">

                            <div class="d-md-flex my-4 justify-content-end">
                                <button class="btn btn-custom" type="submit" :disabled="inviteesLength < 2 ? true: false">Send Invite</button>
                            </div>
                        </div>

                        <div class="d-sm-block d-md-none">
                            <div class="d-md-flex my-4 justify-content-end">
                                <button class="btn btn-custom btn-block" type="submit" :disabled="inviteesLength < 2 ? true: false">Send Invite</button>
                            </div>
                        </div>

                    </div>
                    
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone'
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import { required, minLength } from "vuelidate/lib/validators";

export default {
    components: { 
        vueDropzone,
        Datepicker
    },
    data() {
        return {
            format: "yyyy-MM-dd",

            disabledDates: {
                to: new Date(), // Disable all dates up to specific date
            },
            payout_deadline_disabled: {
                to: new Date(),
            },
            dropzoneOptions: {
                url: 'https://httpbin.org/post',
                maxFilesize: 0.5,
                headers: { "My-Awesome-Header": "header value" },
                dictDefaultMessage: "<i class='fa fa-cloud-upload'></i> Click to select image",
                maxFiles: 4,
                thumbnailWidth: 1000, // px
                thumbnailHeight: 100,
                addRemoveLinks: true
            },
            bindProps: {
                defaultCountry: "NG",
                disabledFetchingCountry: false,
                disabled: false,
                disabledFormatting: false,
                placeholder: "Enter a phone number",
                required: true,
                enabledCountryCode: true,
                enabledFlags: true,
                preferredCountries: ["AU", "BR"],
                onlyCountries: [],
                ignoredCountries: [],
                autocomplete: "off",
                name: "telephone",
                maxLen: 25,
                wrapperClasses: "",
                inputClasses: "",
                dropdownOptions: {
                    disabledDialCode: false
                },
                inputOptions: {
                    showDialCode: false
                }
            },
            form: {
                title: '',
                description: '',
                members_count: '',
                does_org_contrib: 'false',
                amount_payable: '',
                total_amount: 0,
                contrib_deadline: '',
                payout_deadline: '',
                payout_rule: 'organizer-autonomy',
                invitees: [{
                    name: '',
                    phone: '',
                    country: '',
                    email: '',
                    sms_notify: '',
                    email_notify: '',
                    channel: ''
                }]
            },
        }
    },

    validations: {
        form: {
            title: {
                required
            },
            description: {
                required
            },
            does_org_contrib: {
                required
            },
            amount_payable: {
                required
            },
            contrib_deadline: {
                required
            },
            payout_deadline: {
                required
            }
        }
    },

    computed: {
        inviteesLength() {
            return this.form.invitees.length;
        },
        formControl() {
            return "form-control";
        }
    },

    methods: {
        disablePayoutDates(date) {
            let contrib_date = new Date(date);

            let next_day = contrib_date.setDate(contrib_date.getDate() + 1);

            // if contribution is greater than payout
            if (new Date(date) > new Date(this.form.payout_deadline)) {
                this.form.payout_deadline = '';
            }

            this.payout_deadline_disabled = {
                to: new Date(next_day),
            }

        },
        disableContributionDates(date) {
            this.disabledDates = {
                to: new Date(),
            }
        },
        customFormatter(date) {
            return moment(date).format('MMMM Do YYYY, h:mm:ss a');
        },
        getCountry($event, index) {
            this.form.invitees[index].country = $event.iso2;
        },
        removeContributor(index) {
            this.form.invitees.splice(index, 1);
        },
        addContributor() {
            this.form.invitees.push({
                name: '',
                phone: '',
                country: '',
                email: '',
                channel: '',
                sms_notify: '',
                email_notify: '',
            })
        },
        async createPool() {

            let { invitees, amount_payable } = this.form;

            this.form.members_count = invitees.length;

            this.form.total_amount = amount_payable * parseInt(this.form.members_count);

            invitees.map((invitee) => {
                if (invitee.email_notify == true && invitee.sms_notify == false) {
                    invitee.channel = 'email'
                } else if (invitee.sms_notify == true && invitee.email_notify == false) {
                    invitee.channel = 'sms'
                } else if (invitee.sms_notify == true && invitee.email_notify == true) {
                    invitee.channel = 'sms|email'
                } else {
                    invitee.channel = 'email'
                }
            });

            const pool = {...this.form };

            try {
                if (invitees.length < 2) {
                    return false;
                }
                const pool_create = await axios.post('/pool/create', pool);
    
                if (pool_create.status == 200) {
                    const { pool_id } = pool_create.data.message; 
            
                    const pool_invite = await axios.post('/pool/invite', { pool_id, invitees});
    
                    if (pool_invite.status == 200) {
                        this.$notify({
                            group: 'foo',
                            type: 'success',
                            title: 'Success',
                            text: 'Pool has been created and invites have been sent'
                        });

                        this.$router.push('/mypools');
                    }
                }  
            } catch (error) {
                console.log(error.response);
            }
        },
        status(validation) {
            return {
                error: validation.$error,
                dirty: validation.$dirty
            }
        }
    }

}
</script>

<style>
.dirty {
  border-color: #5A5;
  /* background: #EFE; */
    background: #fff;

}

.dirty:focus {
  outline-color: #8E8;
}

.error {
  border-color: red !important;
  /* background: #FDD; */
  background: #fff;
}

.error:focus {
  outline-color: #F99 !important;
}
.fullWidth {
    width: 100%;
}

@media (max-width: 768px) {
    td .form-group input {
        width: 250px;
    }
    
}

</style>